<article id="team-dichotomies">
  <div class="container">
    <div [hidden]="isApiDataLoaded" class="spinner-container relativeWithTopPadding">
      <div class="d-flex justify-content-center">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="isApiDataLoaded">
    <div>
      <div class="intro-title">Preference Pairs</div>
      <div class="intro-copy" [innerHtml]="introduction | safeHtml"></div>
    </div>

    <div class="accordion card-container" id="dichotomies-accordion">
      <div *ngFor="let content of contentObject; index as i" class="card">
        <div class="card-header pointer collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#card' + i">
          <span [innerHtml]="content.source | safeHtml"></span>
          <span class="readmore right">&#xFF0D;</span>
          <span class="readless right">&#xFF0B;</span>
        </div>
        <div id="{{ 'card' + i }}" class="card-body collapse" data-parent="#dichotomies-accordion">
          <div class="summary">
            <div class="question" [innerHtml]="content.question | safeHtml"></div>
            <ul class="answers">
              <li class="answer" *ngFor="let answer of content.answers; index as j">{{ answer }}</li>
            </ul>
          </div>
        </div>
        <div class="detail">
          <div class="detailContainers">
            <div class="detail-row">
              <div
                class="detail-block"
                *ngFor="let detail of content.dichotomyDetail; let index = index"
                [ngClass]="{ 'border-end': 0 === index % 2 }"
              >
                <div class="title" [innerHtml]="detail.title"></div>
                <div class="description" [innerHtml]="detail.description"></div>
              </div>
            </div>
            <div class="detail-row">
              <div
                class="detail-block"
                *ngFor="let detail of content.dichotomyDetail; let index = index"
                [ngClass]="{ 'border-end': 0 === index % 2 }"
              >
                <ul
                  class="member-results"
                  [ngClass]="getMembersByDichotomy(detail.pattern).slice(0, showMoreCount).length > twoColumnCount ? 'two-column' : ''"
                >
                  <li *ngFor="let teamMember of getMembersByDichotomy(detail.pattern).slice(0, showMoreCount)">
                    <span *ngIf="!isMe(teamMember)">{{ teamMember.firstName }} {{ teamMember.lastName }}</span>
                    <span *ngIf="isMe(teamMember)" class="me">You</span>
                  </li>
                </ul>
                <div *ngIf="getMembersByDichotomy(detail.pattern).length > showMoreCount" style="margin-top: -15px">
                  <div class="show-less-item show-less-item-always hide" aria-expanded="false">
                    <ul
                      class="member-results"
                      [ngClass]="getMembersByDichotomy(detail.pattern).slice(showMoreCount).length > twoColumnCount ? 'two-column' : ''"
                    >
                      <li *ngFor="let teamMember of getMembersByDichotomy(detail.pattern).slice(showMoreCount)">
                        <span *ngIf="!isMe(teamMember)">{{ teamMember.firstName }} {{ teamMember.lastName }}</span>
                        <span *ngIf="isMe(teamMember)" class="me">You</span>
                      </li>
                    </ul>
                  </div>
                  <p class="show-more">
                    <a
                      data-show-less-more-button="true"
                      data-show-action="show-more"
                      data-show-more-text="See more"
                      data-show-less-text="See less"
                      href="#"
                      aria-label="Toggle text show/hide"
                    >
                      <span>See more</span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
